import * as log from 'loglevel';
import { logout } from '../auth';

export const IDLE_TIMEOUT_MS = 30 * 60 * 1000;

export const LAST_ACTIVITY_KEY = 'lastActivityAt';
export const LOGOUT_BROADCAST_KEY = 'autoLogoutAt';

const SESSION_STORAGE_KEYS_TO_CLEAR = ['savedPath'];

let loggingOut = false;

export const isLoggingOut = () => loggingOut;

export const resetLoggingOutForTests = () => {
  loggingOut = false;
};

export const markActivity = (timestamp = Date.now()) => {
  try {
    localStorage.setItem(LAST_ACTIVITY_KEY, String(timestamp));
  } catch (e) {
    // ignore storage errors (private mode, quota, etc.)
  }
};

export const getLastActivity = () => {
  try {
    const value = localStorage.getItem(LAST_ACTIVITY_KEY);
    const parsed = value ? parseInt(value, 10) : NaN;
    return Number.isFinite(parsed) ? parsed : null;
  } catch (e) {
    return null;
  }
};

export const broadcastLogout = (timestamp = Date.now()) => {
  try {
    localStorage.setItem(LOGOUT_BROADCAST_KEY, String(timestamp));
  } catch (e) {
    // ignore storage errors
  }
};

export const performAutoLogout = (reason = 'unknown') => {
  if (loggingOut) return;
  loggingOut = true;
  log.info(`performAutoLogout invoked: ${reason}`);

  try {
    SESSION_STORAGE_KEYS_TO_CLEAR.forEach(key => {
      sessionStorage.removeItem(key);
    });
  } catch (e) {
    // ignore storage errors
  }

  broadcastLogout();

  try {
    logout();
  } catch (e) {
    log.error('Auto-logout failed, falling back to reload', e);
    window.location.reload();
  }
};
